<div class="form-container">
  <form nz-form nzLayout="vertical" [formGroup]="umaForm" (ngSubmit)="onSubmit()">
    
    <!-- Form Actions -->
    <nz-form-item class="flex end">
      <button 
        nz-button 
        nzType="primary" 
        type="submit"
        [disabled]="!isFormValid"
        class="excel-button">
        {{ 'Aceptar' }}
      </button>
    </nz-form-item>

    <!-- Año -->
    <nz-form-item>
      <nz-form-label nzFor="anio"><div class="bold-title">Año:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="anioErrorTpl">
        <nz-input-number
          id="anio"
          formControlName="anio"
          [nzMin]="2000"
          [nzMax]="2050"
          [nzStep]="1"
          nzPlaceHolder="Ingresa el año">
        </nz-input-number>
        <ng-template #anioErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            El año es obligatorio
          </ng-container>
          <ng-container *ngIf="control.hasError('min') || control.hasError('max')">
            El año debe estar entre 2000 y 2050
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <!-- Valor UMA -->
    <nz-form-item>
      <nz-form-label nzFor="valorUma"><div class="bold-title">Valor UMA:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="valorErrorTpl">
        <nz-input-number
          id="valorUma"
          formControlName="valorUma"
          [nzMin]="0.01"
          [nzStep]="0.01"
          [nzPrecision]="2"
          nzPlaceHolder="Ingresa el valor UMA">
          <ng-template #nzAddOnBefore>$</ng-template>
        </nz-input-number>
        <ng-template #valorErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            El valor UMA es obligatorio
          </ng-container>
          <ng-container *ngIf="control.hasError('min')">
            El valor UMA debe ser mayor a 0
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <!-- Fecha Inicio -->
    <!-- <nz-form-item>
      <nz-form-label nzFor="fechaInicio"><div class="bold-title">Fecha Inicio:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="fechaInicioErrorTpl">
        <nz-date-picker
          id="fechaInicio"
          formControlName="fechaInicio"
          nzFormat="dd/MM/yyyy"
          nzPlaceHolder="Selecciona fecha de inicio">
        </nz-date-picker>
        <ng-template #fechaInicioErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            La fecha de inicio es obligatoria
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item> -->

    <!-- Fecha Fin -->
    <!-- <nz-form-item>
      <nz-form-label nzFor="fechaFin"><div class="bold-title">Fecha Fin:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="fechaFinErrorTpl">
        <nz-date-picker
          id="fechaFin"
          formControlName="fechaFin"
          nzFormat="dd/MM/yyyy"
          nzPlaceHolder="Selecciona fecha de fin">
        </nz-date-picker>
        <ng-template #fechaFinErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            La fecha de fin es obligatoria
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item> -->

  </form>
</div>
